<template>
  <aside class="c-related-posts">
    <router-link v-if="prevPost" :class="`c-related-post__btn c-related-post__btn--previous c-related-post__btn--${toCssName(prevPost.data.category)}`" :to="{ name: 'post', params: { id: prevPost.uid }}">
      <span class="c-related-post__btn-text">Read Previous</span>
      <div class="c-related-post__content">
        <h5 class="c-related-post__meta-category" v-html="prevPost.data.category"></h5>
        <div class="c-related-post__title-wrapper">
          <h4 class="c-related-post__title">{{getTextContent(prevPost.data.title)}}</h4>
        </div>
      </div>
    </router-link>
    <router-link v-if="nextPost" :class="`c-related-post__btn c-related-post__btn--next c-related-post__btn--${toCssName(nextPost.data.category)}`" :to="{ name: 'post', params: { id: nextPost.uid }}">
      <span class="c-related-post__btn-text">Read Next</span>
      <div class="c-related-post__content">
        <h5 class="c-related-post__meta-category" v-html="nextPost.data.category"></h5>
        <div class="c-related-post__title-wrapper">
          <h4 class="c-related-post__title">{{getTextContent(nextPost.data.title)}}</h4>
        </div>
      </div>
    </router-link>
  </aside>
</template>

<script>
import PrismicDOM from 'prismic-dom'

export default {
  name: 'related-posts',
  props: {
    'prevPost': Object,
    'nextPost': Object,
    'category': String
  },
  methods: {
    getTextContent (str) {
      return str ? PrismicDOM.RichText.asText(str) : ''
    },
    toCssName (str) {
      return str.replace(/\s+/g, '-').toLowerCase()
    }
  }
}
</script>

<style lang="scss" scoped>
.c-related-posts {
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
  display: flex;
  margin-bottom: 5rem;
  position: relative;
  text-align: center;

  @media (min-width: $breakpoint-lg) {
    margin-bottom: 0;
    text-align: left;
  }
}

.c-related-post__btn {
  background-color: #fff;
  flex: 1;
  padding: 1.5rem 1rem .75rem;
  position: relative;
  transition: background-color 200ms ease;

  @media (min-width: $breakpoint-lg) {
    padding: 4rem 3rem 4rem 5rem;
  }
}

.c-related-post__btn--leadership:hover {
  background-color: $leadership;
}

.c-related-post__btn--legal-market:hover {
  background-color: $legal-market;
}

.c-related-post__btn--legal-tech:hover {
  background-color: $legal-tech;
}

.c-related-post__btn--management:hover {
  background-color: $management;
}

.c-related-post__btn--previous {
  border-right: 1px solid #000;
}

.c-related-post__btn-text {
  color: $color-body-content;
  font-size: .8rem;
  position: absolute;
  top: -15px;
  padding: .25rem;
  background-color: #fff;
  border: 1px solid #000;
  font-style: italic;

  @media (min-width: $breakpoint-lg) {
    font-size: 1rem;
    padding: .5rem;
  }
}

.c-related-post__btn:hover .c-related-post__content * {
  border-color: #fff;
  color: #fff;
}

.c-related-post__btn--previous .c-related-post__btn-text {
  left: 50%;
  transform: translateX(-50%);
}

.c-related-post__btn--next .c-related-post__btn-text {
  left: 50%;
  transform: translateX(-50%);
}

.c-related-post__title-wrapper {
  padding-bottom: 1rem;
  position: relative;

  @media (min-width: $breakpoint-lg) {
    border-left: 1px solid #000;
    padding-left: 2rem;
  }

  &:after {
    @media (min-width: $breakpoint-lg) {
      content: "";
      background-color: #000;
      bottom: 0;
      left: -6px;
      position: absolute;
      height: 1px;
      width: 12px;
    }
  }
}

.c-related-post__btn:hover .c-related-post__title-wrapper::after {
  background-color: #fff;
}

.c-related-post__meta-category {
  color: $color-body-content;
  display: inline;
  font-size: .7rem;
  font-style: italic;
  font-weight: 300;
  padding-left: 1.7rem;
  position: relative;
  text-transform: uppercase;

  @media (min-width: $breakpoint-lg) {
    font-size: 1rem;
    padding-left: 2.5rem;
  }

  &::before {
    background-color: red;
    content: "";
    display: block;
    height: 10px;
    left: 0px;
    position: absolute;
    transform: rotate(-45deg);
    top: 0px;
    width: 10px;
  }
}

.c-related-post__btn--leadership .c-related-post__meta-category::before {
  background-color: $leadership;
}

.c-related-post__btn--legal-market .c-related-post__meta-category::before {
  background-color: $legal-market;
}

.c-related-post__btn--legal-tech .c-related-post__meta-category::before {
  background-color: $legal-tech;
}

.c-related-post__btn--management .c-related-post__meta-category::before {
  background-color: $management;
}

.c-related-post__btn:hover .c-related-post__meta-category::before {
  background-color: #fff;
}

.c-related-post__title {
  color: $color-body-content;
  font-family: $font-heading;
  font-size: 1rem;
  margin-bottom: 0;
  text-transform: uppercase;
  weight: $font-heading-weight;

  @media (min-width: $breakpoint-lg) {
    font-size: 1.4rem;
  }
}

</style>



// WEBPACK FOOTER //
// RelatedPosts.vue?257615e4